import './bml-diagnostic-detail.scss';
import { fetchWithAccessCheck, formatDate } from '../../dynamic-page/page-access';
import { loadContentForNewElements } from '../../content-editor-src';

const TEMPLATE = `
<section class="diagnostic-article-content fade-up">
    <div class="article-inner">
        <div class="row">
            <div class="col-md-6">
            </div>
            <div class="col-md-6">
                <h1 id="diagnostic-title" data-animate-child data-content="" data-global="true"></h1>
                <p id="diagnostic-description" data-animate-child data-content="" data-type="textarea"
                   data-global="true"></p>
            </div>
        </div>
    </div>
    <img id="diagnostic-main-image"
         src=""
         class="diagnostic-main-image"
         alt=""
         data-content=""
         data-type="image"
         data-global="true"
         data-animate-child>
    <div class="article-inner">
        <section id="diagnostic-content" class="diagnostic-content fade-up"
                 data-section="diagnostic-content"
                 data-animate-child>
        </section>
    </div>
</section>
`;

class BmlDiagnosticDetail extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;

        const pathMatch = window.location.pathname.match(/^\/diagnostic\/([^/]+)/);
        const slug = pathMatch ? pathMatch[1] : new URLSearchParams(window.location.search).get('slug');
        if (!slug) return;

        this._applyContentIds(slug);
        this._loadData(slug);
    }

    _applyContentIds(slug) {
        document.body.setAttribute('data-page', `Diagnostic - ${slug}`);

        [
            ['#diagnostic-title',       `${slug}-title`],
            ['#diagnostic-description', `${slug}-description`],
            ['#diagnostic-main-image',  `${slug}-image`],
        ].forEach(([selector, contentId]) => {
            const el = this.querySelector(selector);
            if (el) el.setAttribute('data-content', contentId);
        });

        const contentSection = this.querySelector('#diagnostic-content');
        if (contentSection) {
            contentSection.setAttribute('data-page', `Diagnostic - ${slug}`);
        }
    }

    async _loadData(slug) {
        const data = await fetchWithAccessCheck(`/api/diagnostics/slug/${slug}`, 'diagnostic');

        if (data) {
            document.title = `${data.title} - BML`;

            const titleEl = this.querySelector('#diagnostic-title');
            if (titleEl && !titleEl.textContent.trim()) titleEl.textContent = data.title;

            const descEl = this.querySelector('#diagnostic-description');
            if (descEl && !descEl.textContent.trim()) descEl.textContent = data.preview_text || '';
        }

        loadContentForNewElements([...this.querySelectorAll('[data-content]')]);
    }
}

customElements.define('bml-diagnostic-detail', BmlDiagnosticDetail);
